import { useState } from "react";
import { getBidderByUuid, updateBidderForEvent } from "services";

interface UseKycModeSelectionReturn {
  selectingMode: boolean;
  handleKycModeSelection: (mode: "offline" | "online") => Promise<void>;
}

export const useKycModeSelection = (
  bidderUuid: any,
  onModeSelected: () => void
): UseKycModeSelectionReturn => {
  const [selectingMode, setSelectingMode] = useState(false);

  const handleKycModeSelection = async (mode: "offline" | "online") => {
    if (selectingMode) return;

    setSelectingMode(true);
    try {
      const data: any = await getBidderByUuid(bidderUuid);
      await updateBidderForEvent({
        uuid: bidderUuid,
        meta: {
          ...data?.meta,
          bid_application_flow_mode: mode,
        },
      });
      onModeSelected();
    } catch (error) {
      console.error("Error selecting KYC mode:", error);
    } finally {
      setSelectingMode(false);
    }
  };

  return {
    selectingMode,
    handleKycModeSelection,
  };
};
